type LoginElements = {
  $loginElements: HTMLAnchorElement[];
  $registerElements: HTMLAnchorElement[];
  $logoutElements: HTMLAnchorElement[];
  $accountElements: HTMLAnchorElement[];
  $resetPasswordElements: HTMLAnchorElement[];
};

export const getAuthElements = (): LoginElements => {
  const loginElements: NodeListOf<HTMLAnchorElement> =
    document.querySelectorAll('a[href*="/login.php"]');
  const accountElements: NodeListOf<HTMLAnchorElement> =
    document.querySelectorAll('a[href*="/account.php"]');

  const $loginElements: Array<HTMLAnchorElement> = [];
  const $registerElements: Array<HTMLAnchorElement> = [];
  const $logoutElements: Array<HTMLAnchorElement> = [];
  const $accountElements: Array<HTMLAnchorElement> = [];
  const $resetPasswordElements: Array<HTMLAnchorElement> = [];

  loginElements.forEach((element) => {
    const href = element.href;
    const action = new URL(href).searchParams.get('action');

    if (action === 'create_account') {
      $registerElements.push(element);
    } else if (action === 'logout') {
      $logoutElements.push(element);
    } else if (action === 'reset_password') {
      $resetPasswordElements.push(element);
    } else {
      $loginElements.push(element);
    }
  });

  accountElements.forEach((element) => {
    const href = element.href;
    const action = new URL(href).searchParams.get('action');
    if (action === 'account_details') {
      $accountElements.push(element);
    }
  });

  return {
    $loginElements: Array.from($loginElements),
    $registerElements: Array.from($registerElements),
    $logoutElements: Array.from($logoutElements),
    $accountElements: Array.from($accountElements),
    $resetPasswordElements: Array.from($resetPasswordElements),
  };
};
